"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAlignmentControls = addAlignmentControls;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _iterables = require("rich-text-lib/utils/iterables");

var _alignments = require("rich-text-lib/constants/alignments");

var _TinyMceAlignMenu = _interopRequireDefault(require("../components/toolbar/TinyMceAlignMenu"));

var _toolbar = require("../constants/toolbar");

var _alignmentCommandMap;

var alignments = (0, _iterables.pick)(['LEFT', 'CENTER', 'RIGHT', 'JUSTIFY'], _alignments.Alignments);
var alignmentCommandMap = (_alignmentCommandMap = {}, (0, _defineProperty2.default)(_alignmentCommandMap, _alignments.Alignments.LEFT, 'JustifyLeft'), (0, _defineProperty2.default)(_alignmentCommandMap, _alignments.Alignments.CENTER, 'JustifyCenter'), (0, _defineProperty2.default)(_alignmentCommandMap, _alignments.Alignments.RIGHT, 'JustifyRight'), (0, _defineProperty2.default)(_alignmentCommandMap, _alignments.Alignments.JUSTIFY, 'JustifyFull'), _alignmentCommandMap);

var getAlignmentChangeHandler = function getAlignmentChangeHandler(editor) {
  return function (value) {
    editor.execCommand(alignmentCommandMap[value]);
  };
};

var createAlignFormatChangeHandler = function createAlignFormatChangeHandler(editor, formats) {
  editor.formatter.formatChanged(formats.join(','), function (isActive, _ref) {
    var format = _ref.format;
    editor.fire("FormatChanged:" + format, {
      isActive: isActive,
      format: format
    });
  });
};

function addAlignmentControls(editor) {
  var lastAlign = alignments.LEFT;
  var formats = Object.keys(alignments).map(function (key) {
    return "align" + alignments[key];
  });

  if (editor.formatter) {
    createAlignFormatChangeHandler(editor, formats, lastAlign);
  } else {
    editor.on('init', function () {
      createAlignFormatChangeHandler(editor, formats, lastAlign);
    });
  }

  var buttonSettings = {
    type: _toolbar.CANVAS_BUTTON_TYPE,
    renderControl: function renderControl(props) {
      return _react.default.createElement(_TinyMceAlignMenu.default, (0, _extends2.default)({
        editor: editor,
        formats: formats,
        dropdownClassName: "mce-hubspot-menu",
        onChange: getAlignmentChangeHandler(editor),
        getlastAlign: function getlastAlign() {
          return lastAlign;
        },
        setlastAlign: function setlastAlign(align) {
          return lastAlign = align;
        },
        defaultAlignment: alignments.LEFT,
        alignOptions: alignments
      }, props));
    }
  };
  editor.addButton('canvasalignment', buttonSettings);
}